export const getStravaActivityUrl = (id) => {
  return `https://www.strava.com/activities/${id}`
}

export const stravaAthleteUrl = `https://www.strava.com/athletes/229804`
